import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EditIcon from '@material-ui/icons/Edit';
import { NAME_SPACE } from 'i18n';
import { ViewTable, execConfirmModal, ButtonAdd, ButtonDelete } from 'shared';
import { useOperatorsPaginated } from './useOperatorsPaginated';
import { useOperatorsBuildTable } from './useOperatorsBuildTable';
import { useListOperatorsStyles } from './listOperators.styles';
import { PATH } from 'app.routes.const';

export function ListOperators() {
  const classes = useListOperatorsStyles();
  const { operators, getOperators, deleteOperators, errorInfo } = useOperatorsPaginated();
  const { t } = useTranslation(NAME_SPACE.OPERATORS);
  const history = useHistory();

  const { rows, headCells } = useOperatorsBuildTable(operators, t);

  function handleEdit([operatorId]) {
    history.push(PATH.OPERATORS.EDIT.replace(':id', operatorId));
  }

  function handleAdd() {
    history.push(PATH.OPERATORS.CREATE);
  }

  async function handleDelete(operatorsToDelete) {
    try {
      await execConfirmModal({
        title: t('common:actions.remove'),
        description:
          operatorsToDelete.length > 1
            ? t('removeConfirm.message', { length: operatorsToDelete.length })
            : t('removeConfirm.singularMessage', {
                name: operatorsToDelete[0].name
              }),
        confirmText: t('common:actions.accept'),
        declineText: t('common:actions.cancel'),
        confirmClassName: classes.buttonAdd,
        declineClassName: classes.buttonDelete
      });
      await deleteOperators(operatorsToDelete);
    } catch (err) {}
  }

  return (
    <div className={classes.operators}>
      <ViewTable
        elevation
        spaced
        errors={errorInfo}
        rows={rows}
        cells={headCells}
        defaultOrderBy={{ property: 'name', direction: 'asc' }}
        mainKey={'name'}
        onFetchData={getOperators}
        totalRows={operators.total}
        selectRowWhen={element => element.canBeDeleted}
        serverSidePaging
        emptyText={t('empty')}
        actions={[
          {
            title: t('actions.edit'),
            name: 'edit',
            properties: ['id'],
            label: 'edit this row',
            cb: handleEdit,
            icon: <EditIcon />
          }
        ]}
        toolbar={{
          title: t('name'),
          actions: [
            {
              condition: isAnySelected => !isAnySelected,
              cb: handleAdd,
              component: ButtonAdd
            },
            {
              condition: isAnySelected => isAnySelected,
              resetOnCB: true,
              cb: handleDelete,
              component: ButtonDelete
            }
          ]
        }}
      />
    </div>
  );
}
